export default "__VITE_ASSET__11yQHnTxt8hYc5Fxu2Mb7g__"